import {centavosMovimento} from './formasPagamentoMovimento';

// Entradas de adiantamento e suas devolucoes; nunca confundir com o campo pre_pago de uma OS.
export function resumirPrePagamentosCaixa(movimentos) {
  const resumo = {recebidos:0, estornados:0, liquido:0, quantidade:0};
  for (const movimento of Array.isArray(movimentos) ? movimentos : []) {
    if (!movimento || movimento.status !== 'inicial') continue;
    if (movimento.tipo === 'E' && movimento.ref === 'CREDITO_PREPAGO_ENTRADA') {
      resumo.recebidos += centavosMovimento(movimento.valor);
      resumo.quantidade++;
    } else if (movimento.tipo === 'S' && movimento.ref === 'CREDITO_PREPAGO_ESTORNO') {
      resumo.estornados += centavosMovimento(movimento.valor);
    }
  }
  resumo.liquido = resumo.recebidos - resumo.estornados;
  return resumo;
}
